export default "__VITE_ASSET__GDTN_nrl__"